import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 274px;
  background-color: #fafafa;
  color: #373737;

  nav {
    .MuiTypography-body1 {
      font-size: 14px;
    }
  }

  .icon-infusion {
    display: flex;
    align-items: center;

    :before {
      font-size: 24px;
    }
  }

  svg {
    font-size: 24px;
  }
`;
